module.exports = __webpack_public_path__ + "img/vue_logo.24cbbf3a.jpg";